/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ItemUnitAdminDto } from '../models/ItemUnitAdminDto';
import type { ItemUnitAdminListedDtoAdmin } from '../models/ItemUnitAdminListedDtoAdmin';
import type { Pagination1OfItemUnitAdminListedDto } from '../models/Pagination1OfItemUnitAdminListedDto';
import type { PostItemUnitAdminRequest } from '../models/PostItemUnitAdminRequest';
import type { PutItemUnitAdminRequest } from '../models/PutItemUnitAdminRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ItemUnitsService {
    /**
     * **Required Policy:** `ViewItemUnitDetails`
     * @returns ItemUnitAdminDto OK
     * @throws ApiError
     */
    public static getItemUnitAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<ItemUnitAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/itemunits/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageItemUnits`
     * @returns ItemUnitAdminListedDtoAdmin OK
     * @throws ApiError
     */
    public static putItemUnitAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutItemUnitAdminRequest,
    }): CancelablePromise<ItemUnitAdminListedDtoAdmin> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/itemunits/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `DeleteItemUnits`
     * @returns any OK
     * @throws ApiError
     */
    public static deleteItemUnitAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/itemunits/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewItemUnits`
     * @returns Pagination1OfItemUnitAdminListedDto OK
     * @throws ApiError
     */
    public static getItemUnitsAdmin({
        isActive,
        searchWord,
        page,
        limit,
    }: {
        isActive?: boolean,
        searchWord?: string,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfItemUnitAdminListedDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/itemunits',
            query: {
                'isActive': isActive,
                'searchWord': searchWord,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageItemUnits`
     * @returns ItemUnitAdminDto OK
     * @throws ApiError
     */
    public static postItemUnitAdmin({
        requestBody,
    }: {
        requestBody?: PostItemUnitAdminRequest,
    }): CancelablePromise<ItemUnitAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/itemunits',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
